// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Organizations\OrganizationsViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';

// OrganizationsResponseData is the class that OrganizationsResponse serializes to/from
export interface OrganizationsResponseData {
	
    Organizations : OrganizationData[] | null;
	
    CanEditPermissions : boolean;
    CanManageOrgs : boolean;
}

// OrganizationsResponseOptions is the class which may be passed to the OrganizationsResponse constructor to define optional initial data values
export interface OrganizationsResponseOptions {
	
    Organizations? : OrganizationOptions[] | null;
	
    CanEditPermissions? : boolean;
    CanManageOrgs? : boolean;
}

export class OrganizationsResponse {
	
    public Organizations : SDataArray<Organization>;
	
    public CanEditPermissions : DataSignal<boolean>;
    public CanManageOrgs : DataSignal<boolean>;

    constructor();
    constructor(data : OrganizationsResponseOptions);
    constructor(data: OrganizationsResponseOptions | null = null) {
	    
        this.Organizations = SArray<Organization>([]);
	    
        this.CanEditPermissions = jsonableObservable(S.value<boolean>(data && data.CanEditPermissions !== undefined ? data.CanEditPermissions : false));
        this.CanManageOrgs = jsonableObservable(S.value<boolean>(data && data.CanManageOrgs !== undefined ? data.CanManageOrgs : false));
    }

    static key(obj : OrganizationsResponse) {
        return ;
    }
    
    static dataKey(obj : OrganizationsResponseOptions) {
        return ;
    }

    static update(obj : OrganizationsResponse, data : OrganizationsResponseOptions) {
        S.freeze(() => {
	        
	        
            if (data.CanEditPermissions !== undefined) obj.CanEditPermissions(data.CanEditPermissions);
            if (data.CanManageOrgs !== undefined) obj.CanManageOrgs(data.CanManageOrgs);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/OrganizationsResponse.ts